import { getKeycloak } from "./keycloak"
import { refreshSessionNow } from "./tokenRefresh"
import { isSessionIdleLocked } from "./sessionIdle"

export async function initKeycloak() {
  const kc = getKeycloak()
  const hasWebCrypto =
    window.isSecureContext && typeof window.crypto !== "undefined" && !!window.crypto.subtle;

  const initOptions = {
    checkLoginIframe: false,
  };

  if (hasWebCrypto) {
    initOptions.onLoad = "check-sso";
    initOptions.silentCheckSsoRedirectUri = `${window.location.origin}/silent-check-sso.html`;
    initOptions.pkceMethod = "S256";
  } else {
    initOptions.onLoad = "login-required";
    initOptions.pkceMethod = false;
    console.warn(
      "Running without Web Crypto secure context. Falling back to login-required without PKCE. Use HTTPS for full Keycloak security features."
    );
  }

  const authenticated = await kc.init(initOptions)

  if (authenticated && kc.token) {
    localStorage.setItem("authToken", kc.token);
  }

  kc.onTokenExpired = async () => {
    if (isSessionIdleLocked()) {
      localStorage.removeItem("authToken");
      await kc.logout({ redirectUri: window.location.origin });
      return;
    }
    try {
      await refreshSessionNow();
    } catch (err) {
      console.error("Token refresh on expiry failed", err);
      localStorage.removeItem("authToken");
      await kc.login({ redirectUri: window.location.href });
    }
  };

  return authenticated;
}
